import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableClientCreatePage } from '../../Pages/Clients/ClientCreate/LoadableClientCreatePage';
import { LoadableClientDetailsPage } from '../../Pages/Clients/ClientDetails/LoadableClientDetailsPage';
import { LoadableListClientPage } from '../../Pages/Clients/ListClient/LoadableListClientPage';

const getListClientRoute = (props: object): AppRouteType => ({
    id: AppRoutes.CLIENT_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CLIENT_LIST,
        component: LoadableListClientPage,
        ...props,
    },
});

const getCreateClientRoute = (props: object): AppRouteType => ({
    id: AppRoutes.CLIENT_CREATE,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CLIENT_CREATE,
        component: LoadableClientCreatePage,
        ...props,
    },
});

const getDetailsClientRoute = (props: object): AppRouteType => ({
    id: AppRoutes.CLIENT_DETAILS,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.CLIENT_DETAILS,
        component: LoadableClientDetailsPage,
        ...props,
    },
});

export const getClientRoutes = (args: object) => [
    getListClientRoute(args),
    getCreateClientRoute(args),
    getDetailsClientRoute(args),
];
